import React from 'react';
import { Modal, Box, Alert, Button, theme } from '@agilize/components-core';
import { ConfirmationDialogProps } from './ConfirmationModal.types';

const ConfirmationModal = (props: ConfirmationDialogProps) => {
  const { isOpen, onClose, onConfirm, message, alertMessage, cancelButtonMessage, hideCancelButton, textButton, colorButton, isLoading, title } = props;

  const handleClose = () => onClose();

  const handleConfirm = () => onConfirm();

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title={title || 'Confirmação'} size="small" loading={isLoading}>
      <Box fontSize={theme.fontSizes[2]} lineHeight="22px" mb={theme.global.gutterSpace * 1.25}>
        {message || 'Você tem certeza que deseja remover?'}
      </Box>
      {alertMessage && <Alert type="warning" title="" description={alertMessage} />}
      <Box mt={theme.global.gutterSpace * 1.5} display="flex" justifyContent="flex-end">
        {!hideCancelButton && (
          <Button type="button" size="medium" variant="text" onClick={handleClose} disabled={isLoading}>
            {cancelButtonMessage || 'Cancelar'}
          </Button>
        )}
        <Box ml={theme.global.gutterSpace}>
          <Button
            testId="confirm-remove"
            type="button"
            size="medium"
            buttonColor={colorButton || theme.colors.red700}
            textColor={theme.colors.white}
            onClick={handleConfirm}
            loading={isLoading}>
            {textButton || 'Remover'}
          </Button>
        </Box>
      </Box>
    </Modal>
  );
};

export default ConfirmationModal;
